var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }